function numP(a: any, b: any): number {
    return (a !== undefined && a !== null) ? a : (b || 0);
}

export class ChatPromptDto {
    public id: number = 0;
    public idCliente: number = 0;
    public nombre: string = "";
    public descripcion: string = "";
    public contenido: string = "";
    public activo: boolean = true;
    public orden: number = 0;
    public esSistema: boolean = false;
    public tipoDepartamento: string = "";
    public estadoValidacion: string = "";
    public evaluacionRrhh: string = "";

    constructor(data?: any) {
        if (!data) { return; }
        this.id               = numP(data.Id,         data.id);
        this.idCliente        = numP(data.Id_cliente,  data.id_cliente);
        this.nombre           = data.Nombre           || data.nombre           || "";
        this.descripcion      = data.Descripcion      || data.descripcion      || "";
        this.contenido        = data.Contenido        || data.contenido        || "";
        this.activo           = data.Activo !== undefined ? data.Activo : (data.activo !== undefined ? data.activo : true);
        this.orden            = numP(data.Orden, data.orden);
        this.esSistema        = data.EsSistema        !== undefined ? data.EsSistema        : (data.es_sistema        !== undefined ? data.es_sistema        : false);
        this.tipoDepartamento = data.TipoDepartamento || data.tipo_departamento || "";
        this.estadoValidacion = data.EstadoValidacion || data.estado_validacion || "";
        this.evaluacionRrhh   = data.EvaluacionRrhh   || data.evaluacion_rrhh   || "";
    }

    public get esDepartamento(): boolean {
        return this.tipoDepartamento !== "" && this.tipoDepartamento !== null;
    }

    public get rrhhAprobado(): boolean {
        return this.estadoValidacion === "aprobado";
    }

    public get rrhhData(): any {
        if (!this.evaluacionRrhh) { return null; }
        try { return JSON.parse(this.evaluacionRrhh); } catch (e) { return null; }
    }

    public toJson(): object {
        return {
            id:                this.id,
            id_cliente:        this.idCliente,
            nombre:            this.nombre,
            descripcion:       this.descripcion,
            contenido:         this.contenido,
            activo:            this.activo,
            orden:             this.orden,
            es_sistema:        this.esSistema,
            tipo_departamento: this.tipoDepartamento,
            estado_validacion: this.estadoValidacion,
            evaluacion_rrhh:   this.evaluacionRrhh
        };
    }
}
